export enum LocalStorageKeys {
    AccessToken = 'accessToken',
}


const isStorageAvailable = () => typeof window === 'undefined';
export const setStoreItem = (key: LocalStorageKeys, value: any) => {
    if (isStorageAvailable()) {
        return
    }
    window.localStorage.setItem(key, JSON.stringify(value))
}

export const getStoreItem = <T>(key: LocalStorageKeys) => {
    if (isStorageAvailable()) {
        return null;
    }
    return JSON.parse(window.localStorage.getItem(key)) as T
}

export const removeStoreItem = (key: LocalStorageKeys) => {
    if (isStorageAvailable()) {
        return
    }
    window.localStorage.removeItem(key)
}